import React from 'react';
import Navbar from '../components/layout/Navbar';
import AddMeetingForm from '../components/layout/AddMeetingForm';

function AddMeetingPage() {
  return (
    <div>
      <Navbar />
      <div className='container'>
        <br />
        <h2>Add a Meeting</h2>
        <AddMeetingForm />
      </div>
    </div>
  );
}

export default AddMeetingPage;
